import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule }  from '@angular/forms';

import { ManageCurriculumComponent } from './manage-curriculum.component';

import { AngularMaterialModule } from '../angular-material.module';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AngularMaterialModule
  ],
  providers: [
 
  ],
  declarations: [
    ManageCurriculumComponent,
  ],
  exports: [
    ManageCurriculumComponent,
  ]
})
export class ManageCurriculumModule { }
